/** Matches `documents.entity_type` for BOQ line row attachments. */
export const DOCUMENT_ENTITY_TYPE_BOQ_LINE_ITEM = 'BOQ_LINE_ITEM';

/** Shown on work orders, shop floor, and other manufacturing views. */
export const BOQ_LINE_DOCUMENT_CATEGORY_TECHNICAL = 'Technical';

/** Line files that stay on the estimation record and are not opened from manufacturing. */
export const BOQ_LINE_DOCUMENT_CATEGORY_ATTACHMENT = 'Attachment';
export const DOCUMENT_ENTITY_TYPE_PMV_DAILY_LOG = 'PMV_DAILY_LOG';
export const DOCUMENT_ENTITY_TYPE_TRADING_RENTAL_ESTIMATION_LINE = 'TRADING_RENTAL_ESTIMATION_LINE';

/** EST3 revision / estimate evidence — aligns with approval entity type `epc_estimate`. */
export const DOCUMENT_ENTITY_TYPE_EPC_ESTIMATE_REVISION = 'epc_estimate';

/** Finance / procurement documents linked via `documents.entity_type` + `entity_id`. */
export const DOCUMENT_ENTITY_TYPE_PAYMENT_VOUCHER = 'PaymentVoucher';
export const DOCUMENT_ENTITY_TYPE_RECEIPT_VOUCHER = 'ReceiptVoucher';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_ADVANCE_REQUEST = 'SupplierAdvanceRequest';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_ADVANCE_REFUND_VOUCHER = 'SupplierAdvanceRefundVoucher';
export const DOCUMENT_ENTITY_TYPE_SALES_INVOICE = 'SalesInvoice';
export const DOCUMENT_ENTITY_TYPE_CUSTOMER_CREDIT_NOTE = 'CustomerCreditNote';

/** SCM / procurement document attachments. */
export const DOCUMENT_ENTITY_TYPE_PURCHASE_REQUISITION = 'PurchaseRequisition';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_INQUIRY = 'SupplierInquiry';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_QUOTATION = 'SupplierQuotation';
export const DOCUMENT_ENTITY_TYPE_BID_ANALYSIS = 'BidAnalysis';
export const DOCUMENT_ENTITY_TYPE_PURCHASE_ORDER = 'PurchaseOrder';
export const DOCUMENT_ENTITY_TYPE_GOODS_RECEIPT_NOTE = 'GoodsReceiptNote';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_INVOICE = 'SupplierInvoice';
export const DOCUMENT_ENTITY_TYPE_PURCHASE_RETURN = 'PurchaseReturn';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER = 'Supplier';
export const DOCUMENT_ENTITY_TYPE_MATERIAL_REQUEST = 'MaterialRequest';
export const DOCUMENT_ENTITY_TYPE_STOCK_ADJUSTMENT = 'StockAdjustment';
export const DOCUMENT_ENTITY_TYPE_OUTSOURCING_ORDER = 'OutsourcingOrder';
export const DOCUMENT_ENTITY_TYPE_SUPPLIER_ASSESSMENT = 'SupplierAssessment';
export const DOCUMENT_ENTITY_TYPE_SPOT_PURCHASE_OFFER = 'SpotPurchaseOffer';

/** EPC IPC measurement / progress evidence (measurement sheets, inspection reports, photos). */
export const DOCUMENT_ENTITY_TYPE_EPC_PAYMENT_APPLICATION = 'EpcPaymentApplication';

/** CSPM customer property attachments. */
export const DOCUMENT_ENTITY_TYPE_CUSTOMER_PROPERTY_RECEIPT = 'CustomerPropertyReceipt';
export const DOCUMENT_ENTITY_TYPE_CUSTOMER_PROPERTY_REQUIREMENT = 'CustomerPropertyRequirement';
export const DOCUMENT_ENTITY_TYPE_CUSTOMER_PROPERTY_EXCEPTION = 'CustomerPropertyException';
export const DOCUMENT_ENTITY_TYPE_CUSTOMER_PROPERTY_RETURN = 'CustomerPropertyReturn';

/** Control of TMMDE — calibration certificates and external-source verification evidence. */
export const DOCUMENT_ENTITY_TYPE_CALIBRATION_RECORD = 'CalibrationRecord';
export const DOCUMENT_ENTITY_TYPE_TMMDE_EXTERNAL_VERIFICATION = 'TmmdeExternalVerification';
export const DOCUMENT_ENTITY_TYPE_TMMDE_IMPACT_ASSESSMENT = 'TmmdeImpactAssessment';

/** Personnel competency and training — signed attendance sheets, assessment and effectiveness evidence. */
export const DOCUMENT_ENTITY_TYPE_TRAINING_SESSION = 'TrainingSession';
export const DOCUMENT_ENTITY_TYPE_COMPETENCY_ASSESSMENT = 'CompetencyAssessment';
export const DOCUMENT_ENTITY_TYPE_TRAINING_EFFECTIVENESS = 'TrainingEffectiveness';
export const DOCUMENT_ENTITY_TYPE_MANAGEMENT_REVIEW = 'ManagementReviewMeeting';
export const DOCUMENT_ENTITY_TYPE_CONTROLLED_DOCUMENT = 'ControlledDocument';

/** Education compartment records; upload only through compartment-scoped Education APIs. */
export const DOCUMENT_ENTITY_TYPE_EDU_HEALTH_RECORD = 'EduHealthRecord';
export const DOCUMENT_ENTITY_TYPE_EDU_COUNSELING_CASE = 'EduCounselingCase';
export const DOCUMENT_ENTITY_TYPE_EDU_SAFEGUARDING_CASE = 'EduSafeguardingCase';

export const SCM_ATTACHMENT_UPLOAD_HINT =
  'PDF, images, or Office files, up to 25MB each; max 20 files per record.';

export const BOQ_LINE_DOCUMENT_MAX_COUNT = 20;

export const BOQ_LINE_DOCUMENT_MAX_BYTES = 25 * 1024 * 1024;

/** Lowercase extensions allowed for BOQ line technical uploads (server-enforced). */
export const BOQ_LINE_ALLOWED_FILE_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
] as const;
